const noResultData = {
  title: 'Sorry, we can’t find what you’re looking for.',
  description: 'Try making your search simpler, double-check your spelling, or create your own.',
  buttonLabel: 'Create your own design',
  href: '/create/editor?customSize=1080x1080&unit=px&category=layout',
};

export default noResultData;
